/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useToasts } from "react-toast-notifications";

import { callApiPost } from 'Core/services/api';

import { AreaInput } from "../ui/AreaInput";

const setHomeworkQuestion = async ({ id, question }) => callApiPost(`/homeworks/${id}/update-question`, { question });

export const HomeworkQuestion = ({ activeWork, readonly }) => {
  const { addToast } = useToasts();
  const [questionValue, setQuestionValue] = useState(activeWork.question);

  const handleSubmit = async (value) => {
    const { response } = await setHomeworkQuestion({ id: activeWork.id, question: value });
    if (response.ok) {
      setQuestionValue(value);
      addToast("Вопрос сохранен", {
        appearance: "success",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });

      return;
    }

    addToast("Произошла ошибка", {
      appearance: "error",
      autoDismiss: true,
      autoDismissTimeout: 3000,
    });
  };

  return (
    <AreaInput
      value={questionValue}
      handleSubmit={handleSubmit}
      name="question"
      placeholder="Написать вопрос..."
      btnText="Отправить"
      readonly={readonly}
    />
  );
};
